module.exports = __webpack_public_path__ + "img/indexl.94de0234.png";